<template>
    <div>
        <form data-vv-scope="personal_data">
            <span class="block text-center text-2xl font-bold mb-8">{{
                $t("past_education")
            }}</span>

            <div :class="classForDOM.grandParent">
                <vs-card>
                    <div :class="classForDOM.parent">
                        <div :class="classForDOM.block" class="p-1">
                            <MultiselectCustom
                                endpoint="organizations/edu-types/"
                                :disabled="disabled"
                                @selected="setStatusForShowSelectSpeciality"
                                @removed="hideStatusForShowSelectSpeciality"
                                name="education_type"
                                v-validate="'required'"
                                :placeholder="`${$t('education_type')}*`"
                                v-model="education.edu_type"
                            />
                            <ValidateText
                                field="education_type"
                                scope="personal_data"
                                :error="errors"
                            />
                        </div>
                        <div :class="classForDOM.block" class="p-1">
                            <MultiselectCustom
                                endpoint="common/doc-types/group/?code=edu_docs"
                                :disabled="disabled"
                                name="document_type"
                                v-validate="'required'"
                                :placeholder="`${$t('document_type')}*`"
                                v-model="education.document_type"
                            />
                            <ValidateText
                                field="document_type"
                                scope="personal_data"
                                :error="errors"
                            />
                        </div>
                        <div :class="classForDOM.block" class="p-1">
                            <MultiselectCustom
                                endpoint="organizations/study-forms/"
                                :disabled="disabled"
                                name="study_form"
                                v-validate="'required'"
                                :placeholder="`${$t('study_form')}*`"
                                v-model="education.study_form"
                            />
                            <ValidateText
                                field="study_form"
                                scope="personal_data"
                                :error="errors"
                            />
                        </div>
                    </div>
                    <div :class="classForDOM.parent">
                        <div
                            :class="classForDOM.block"
                            class="p-1"
                            style="max-width: 50%"
                            v-if="statusShowSelectSpeciality"
                        >
                            <MultiselectCustom
                                endpoint="organizations/edu-programs/"
                                :disabled="disabled"
                                name="education_program"
                                v-validate="'required'"
                                :placeholder="`${$t('education_program')}*`"
                                v-model="education.education_program"
                            />
                            <ValidateText
                                field="education_program"
                                scope="personal_data"
                                :error="errors"
                            />
                        </div>
                        <div :class="classForDOM.block" class="p-1">
                            <template v-if="!myInstituteNotHaveInList">
                                <MultiselectCustom
                                    endpoint="organizations/organizations/search/"
                                    :disabled="disabled"
                                    name="institute"
                                    prevEndpoint="organizations/organizations/"
                                    searchObjectEndpoint="organizations/organizations/"
                                    searchKey="name"
                                    v-validate="'required'"
                                    :placeholder="`${$t('write_institute')}*`"
                                    v-model="education.institute"
                                />
                                <ValidateText
                                    field="institute"
                                    scope="personal_data"
                                    :error="errors"
                                />
                            </template>
                            <template v-else>
                                <vs-input
                                    :label-placeholder="`${$t(
                                        'institute_text'
                                    )}*`"
                                    :disabled="disabled"
                                    v-validate="'required'"
                                    name="institute_text"
                                    v-model="education.institute_text"
                                    class="mt-8 flex-auto p-1 w-full"
                                />
                                <ValidateText
                                    field="institute_text"
                                    scope="personal_data"
                                    :error="errors"
                                />
                            </template>
                            <vs-checkbox
                                v-model="myInstituteNotHaveInList"
                                :disabled="disabled"
                                style="z-index: 1"
                            >
                                {{ $t("my_institute_not_have_in_list") }}
                            </vs-checkbox>
                        </div>
                    </div>
                    <div :class="classForDOM.parent">
                        <div :class="classForDOM.block">
                            <vs-input
                                :label-placeholder="`${$t('serial_number')}*`"
                                :disabled="disabled"
                                v-validate="'required'"
                                name="serial_number"
                                v-model="education.serial_number"
                                class="mt-8 flex-auto p-1 w-full"
                            />
                            <ValidateText
                                field="serial_number"
                                scope="personal_data"
                                :error="errors"
                            />
                        </div>
                        <div :class="classForDOM.block">
                            <vs-input
                                :label-placeholder="`${$t('number')}*`"
                                :disabled="disabled"
                                v-validate="'required'"
                                name="number"
                                v-model="education.number"
                                class="mt-8 flex-auto p-1 w-full"
                            />
                            <ValidateText
                                field="number"
                                scope="personal_data"
                                :error="errors"
                            />
                        </div>
                        <div :class="classForDOM.block">
                            <DatepickerCustom
                                v-model="education.given_date"
                                :disabled="disabled"
                                name="given_date"
                                v-validate="'required'"
                                :placeholder="`${$t('given_date')}*`"
                            />
                            <ValidateText
                                field="given_date"
                                scope="personal_data"
                                :error="errors"
                            />
                        </div>
                        <div :class="classForDOM.block">
                            <vs-input
                                :label-placeholder="`${$t('avg_mark')}*`"
                                :disabled="disabled"
                                v-validate="'required|validAvgMark|between:1,5'"
                                name="avg_mark"
                                v-model="education.avg_mark"
                                class="mt-8 flex-auto p-1 w-full"
                            />
                            <ValidateText
                                field="avg_mark"
                                scope="personal_data"
                                :error="errors"
                            />
                        </div>
                    </div>
                    <div :class="classForDOM.parent" class="mt-4">
                          <div :class="classForDOM.block">
                            <vs-checkbox
                                :disabled="disabled"
                                style="z-index: 1"
                                v-model="education.is_flawless_graduate"
                            >
                                {{ $t("is_flawless_graduate") }}
                            </vs-checkbox>
                        </div>
                        <div :class="classForDOM.block">
                            <vs-checkbox
                                :disabled="disabled"
                                v-model="education.is_honorable_graduate"
                                style="z-index: 1"
                                v-if="!statusShowSelectSpeciality"
                            >
                                {{ $t("is_honorable_graduate") }}
                            </vs-checkbox>
                        </div>

                        <div :class="classForDOM.block">
                            <vs-checkbox
                                :disabled="disabled"
                                style="z-index: 1"
                                v-model="education.is_NIS_graduate"
                                v-if="!statusShowSelectSpeciality"
                            >
                                {{ $t("is_NIS_graduate") }}
                            </vs-checkbox>
                        </div>
                    </div>
                    <template v-if="file_upload_limitation">
                        <span class="text-base font-medium pt-4 block pl-2"
                            >{{ $t("upload_the_required_documents") }}*</span
                        >
                        <span
                            v-if="!education.files.length"
                            class="pl-2 text-danger"
                            >{{ $t("please_add_files") }}</span
                        >
                        <div :class="classForDOM.parent">
                            <vs-upload
                                :text="$t('upload_file')"
                                :action="'common/upload/'"
                                :disabled="disabled"
                                @on-success="setEducationFiles"
                                @prev-delete="removeEducationFile"
                                :single-upload="true"
                                :firstFiles="education.files"
                                :automatic="true"
                                :max-size="
                                    file_upload_limitation['max_file_size']
                                "
                                :fileName="'path'"
                            />
                        </div>
                    </template>
                </vs-card>
            </div>
        </form>
    </div>
</template>

<script>
import MultiselectCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/MultiselectCustom";
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";
import DatepickerCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/DatepickerCustom";

import { Validator } from "vee-validate";

const validatorForIIN = {
    getMessage: (field, opt1, top2) => {
        const currentLang = window.location.pathname.substring(1, 3);
        const message = {
            ru:
                "Средний балл должен быть между 1.0 и 4.0. Для школьников от 1.0 до 5.0",
            kk:
                "Орташа балл 1.0 және 4.0 арасында болуы керек. Мектеп түлектері үшін 1.0-ден 5.0-ге дейін",
            en:
                "The average score should be between 1.0 and 4.0. 1.0 to 5.0 for high school graduates",
        };
        return message[currentLang];
    },
    validate: (value) => {
        return value <= 5 && value >= 1;
    },
};

Validator.extend("validAvgMark", validatorForIIN);

export default {
    name: "PastEducation",
    props: {
        file_upload_limitation: {
            type: Object,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            education: {
                document_type: "",
                edu_type: "",
                study_form: "",
                education_program: "",
                serial_number: "",
                number: "",
                given_date: "",
                avg_mark: "",
                is_honorable_graduate: false,
                is_flawless_graduate: false,
                is_NIS_graduate: false,
                institute: "",
                files: [],
                profile: this.data.profile.uid,
                uid: null,
            },
            statusShowSelectSpeciality: true,
            myInstituteNotHaveInList: false,
            classForDOM: {
                grandParent: "flex flex-col md:flex-row justify-between",
                parent: "flex flex-col md:flex-row justify-between items-start",
                block: "flex flex-col w-full",
            },
        };
    },
    components: {
        MultiselectCustom,
        ValidateText,
        DatepickerCustom,
    },
    methods: {
        async saveAllData() {
            try {
                this.$vs.loading();
                const pastEducation = this.education?.uid;

                let clone = { ...this.education };
                clone.files = await clone.files.map((e) => e.response.uid);

                (
                    await this.$http[pastEducation ? "patch" : "post"](
                        `admissions/educations/${
                            pastEducation ? pastEducation + "/" : ""
                        }`,
                        clone
                    )
                ).data;
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        validateStep() {
            if (!this.disabled) {
                return this.$validator
                    .validateAll("personal_data")
                    .then(async (result) => {
                        if (result && this.education.profile.length) {
                            await this.saveAllData();

                            await this.$emit("setNewDataInObject", {
                                name: "education",
                                data: this.education,
                            });
                            return true;
                        } else {
                            return false;
                        }
                    });
            } else {
                return true;
            }
        },
        setStatusForShowSelectSpeciality(value) {
            if (value.code === "GENERAL_OVERALL") {
                this.statusShowSelectSpeciality = false;

                this.education.education_program = "";
                this.education.is_NIS_graduate = false;
                this.education.is_honorable_graduate = false;
            } else this.hideStatusForShowSelectSpeciality();
        },
        hideStatusForShowSelectSpeciality() {
            this.statusShowSelectSpeciality = true;
            this.education.education_program = "";
        },
        setEducationFiles(response) {
            if (!this.education.files) this.id.files = [];
            if (
                this.education.files.findIndex(
                    ({ name }) => name === response[0].name
                )
            ) {
                const firstFiles = this.education.files.filter(
                    (i) => i.firstFile || i.name !== response[0].name
                );
                const newFiles = response.map((item) => {
                    return {
                        ...item,
                        response: item,
                    };
                });
                this.education.files = firstFiles.concat(newFiles);
            } else {
                this.education.files = this.education.files.concat(
                    response.map((item) => {
                        return {
                            ...item,
                            response: item,
                        };
                    })
                );
            }
        },
        async removeEducationFile({ file, done }) {
            this.education.files = await this.education.files.filter(
                (item) => item.response.uid !== file.response.uid
            );
            done();
        },
    },
    created() {
        if (this.data.education) {
            let clone = { ...this.data.education };

            if (clone.files.length) {
                clone.files = clone.files.map((file) => {
                    return {
                        ...file,
                        firstFiles: true,
                        response: file,
                    };
                });
            }

            this.education = clone;

            if (
                this.education.code &&
                this.education.code === "GENERAL_OVERALL"
            ) {
                this.statusShowSelectSpeciality = false;

                this.education.education_program = "";
                this.education.is_NIS_graduate = false;
                this.education.is_honorable_graduate = false;
            }
        }
    },
    watch: {
        myInstituteNotHaveInList() {
            setTimeout(() => {
                this.education.institute = "";
                this.education.institute_text = "";
            }, 300);
        },
        $route: {
            handler() {
                Validator.extend("validAvgMark", validatorForIIN);
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
</style>
